import { render, staticRenderFns } from "./PopoutPDFViewer.vue?vue&type=template&id=88d5f310&"
import script from "./PopoutPDFViewer.vue?vue&type=script&lang=js&"
export * from "./PopoutPDFViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports